module.exports = __webpack_public_path__ + "files/5139e20290ca123781dbab66d35b1870.svg";